import React, { Fragment } from 'react';
import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { Row, Col } from 'react-bootstrap';
import messages from './reportGeneralPanelTRIMessages';
import ResultCard from '../ReportResultCard';


const StudentDetailCard = props => {
  return (
    <Fragment>
      <Row>
        <Col xs={6} md={6} lg={4} xl={4}>
          <ResultCard
            cardTRI
            label={props.intl.formatMessage(messages.countStudents)}
            value={props.cardDetailStudentTRI.countStudents}
          />
        </Col>
        <Col xs={6} md={6} lg={4} xl={4}>
          <ResultCard
            cardTRI
            label={props.intl.formatMessage(messages.studentEvaluationPosition)}
            value={props.cardDetailStudentTRI.evaluationStudentRank}
          />
        </Col>
        <Col xs={6} md={6} lg={4} xl={4}>
          <ResultCard
            cardTRI
            label={props.intl.formatMessage(messages.studentGroupPosition)}
            value={props.cardDetailStudentTRI.groupStudentRank}
          />
        </Col>
        <Col xs={6} md={6} lg={4} xl={4}>
          <ResultCard
            cardTRI
            label={props.intl.formatMessage(messages.studentSchoolPosition)}
            value={props.cardDetailStudentTRI.schoolStudentRank}
          />
        </Col>
        <Col xs={6} md={6} lg={4} xl={4}>
          <ResultCard
            cardTRI
            label={props.intl.formatMessage(messages.studentAvg)}
            value={props.cardDetailStudentTRI.avgStudent}
          />
        </Col>
        <Col xs={6} md={6} lg={4} xl={4}>
          <ResultCard
            cardTRI
            label={props.intl.formatMessage(messages.gradeLC)}
            value={props.cardDetailStudentTRI.LCGrade}
          />
        </Col>
        <Col xs={6} md={6} lg={4} xl={4}>
          <ResultCard
            cardTRI
            label={props.intl.formatMessage(messages.gradeCH)}
            value={props.cardDetailStudentTRI.CHGrade}
          />
        </Col>
        <Col xs={6} md={6} lg={4} xl={4}>
          <ResultCard
            cardTRI
            label={props.intl.formatMessage(messages.gradeCN)}
            value={props.cardDetailStudentTRI.CNGrade}
          />
        </Col>
        <Col xs={6} md={6} lg={4} xl={4}>
          <ResultCard
            cardTRI
            label={props.intl.formatMessage(messages.gradeMT)}
            value={props.cardDetailStudentTRI.MTGrade}
          />
        </Col>
        <Col xs={6} md={6} lg={4} xl={4}>
          <ResultCard
            cardTRI
            label={props.intl.formatMessage(messages.writing)}
            value={props.cardDetailStudentTRI.writingGrade}
          />
        </Col>
      </Row>
    </Fragment>
  )

};

export default compose(injectIntl)(StudentDetailCard);
